import { motion } from 'framer-motion';
import { Brain, Users, ShieldCheck, Mail } from 'lucide-react';

export default function DashboardActivity({ wins, leads }) {
  return (
    <>
      {/* This week's wins */}
      {wins.length > 0 && (
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="mb-4">
          <h3 className="text-[13px] font-medium mb-3" style={{ color: '#3C3226' }}>This week's wins</h3>
          <div className="space-y-2">
            {wins.map((win) => (
              <div key={win.text?.slice(0, 30) || win.type} className="p-4 rounded-sm bg-[#F7F4EF] flex items-center gap-3" style={{ border: '1px solid #D4C9B8' }} data-testid={`win-${win.type || 'item'}`}>
                <div className="w-8 h-8 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(29,158,117,0.06)' }}>
                  {win.icon === 'brain' ? <Brain size={16} style={{ color: '#1D6B4F' }} strokeWidth={1.5} /> :
                   win.icon === 'users' ? <Users size={16} style={{ color: '#1D6B4F' }} strokeWidth={1.5} /> :
                   <ShieldCheck size={16} style={{ color: '#1D6B4F' }} strokeWidth={1.5} />}
                </div>
                <span className="text-[13px]" style={{ color: '#3C3226' }}>{win.text}</span>
              </div>
            ))}
          </div>
        </motion.div>
      )}

      {/* Leads (Professional tier) */}
      {leads.length > 0 && (
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.27 }} className="mb-4">
          <h3 className="text-[13px] font-medium mb-3" style={{ color: '#3C3226' }}>Recent inquiries</h3>
          <div className="space-y-2">
            {leads.slice(0, 3).map((lead) => (
              <div key={lead.lead_id} className="p-4 rounded-sm bg-[#F7F4EF] flex items-center gap-3" style={{ border: '1px solid #D4C9B8' }} data-testid={`lead-${lead.lead_id}`}>
                <div className="w-8 h-8 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: lead.status === 'new' ? 'rgba(198,122,92,0.08)' : '#F7F4EF' }}>
                  <Mail size={15} style={{ color: lead.status === 'new' ? '#C67A5C' : '#8C7E6E' }} strokeWidth={1.5} />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-[13px] font-medium block" style={{ color: '#3C3226' }}>{lead.name}</span>
                  <span className="text-[12px] truncate block" style={{ color: '#8C7E6E' }}>{lead.message || lead.email || lead.phone}</span>
                </div>
                {lead.status === 'new' && (
                  <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: '#C67A5C' }} />
                )}
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </>
  );
}
